__turbopack_context__.v({
  "annotationFrame": "hhLOTa_annotationFrame",
  "annotationLabel": "hhLOTa_annotationLabel",
  "annotationPrefix": "hhLOTa_annotationPrefix",
  "cornerDot": "hhLOTa_cornerDot",
  "hudAnnotationWrapper": "hhLOTa_hudAnnotationWrapper",
});
